module.exports = __webpack_public_path__ + "img/role.eacbed0f.svg";